import { Component, OnInit } from '@angular/core';
import { LocalStorageProvider } from 'app/shared';

@Component({
  selector: 'app-cookie-info',
  templateUrl: './cookie-info.component.html',
  styleUrls: ['./cookie-info.component.scss']
})
export class CookieInfoComponent {

  public cookieInfoVisibility: boolean = false;

  constructor(
    private storage: LocalStorageProvider
  ) {
    this.cookieInfoVisibility = this.storage.get('cookieVisibility') === null
  }

  public hideCookieInfo(): void {
    this.storage.set('cookieVisibility', false);
    this.cookieInfoVisibility = false;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/ui/cookie-info/cookie-info.component.ts